export default {
  namespaced: true,
  state: {
    clientHeight: ""
  },
  getters: {
    /**
     * 高度尺寸
     * @param {ga} per 
     */
    getValue(state, per) {
      return state.clientHeight
      // return (per * state.clientHeight) / 100 + "px";
    }
  },

  mutations: {
    setHeight(state, clientHeight) {
      state.clientHeight = clientHeight
    }
  }
}